export const ATTRIBUTI = 'ATTRIBUTI'